var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9222 14.6704L16.98 12.7282C16.6285 12.3769 16.1882 12.1275 15.7061 12.0068C15.2241 11.8861 14.7182 11.8984 14.2426 12.0426C13.767 12.1867 13.3395 12.4573 13.0056 12.8254C12.6717 13.1935 12.4439 13.6453 12.3467 14.1326C9.14387 13.5337 6.02887 10.4315 5.83498 7.65874C6.37947 7.55858 6.88057 7.29505 7.27165 6.90318C7.78657 6.3882 8.07584 5.68977 8.07584 4.96152C8.07584 4.23326 7.78657 3.53484 7.27165 3.01985L5.32998 1.07763C4.815 0.56271 4.11657 0.273437 3.38832 0.273438C2.66007 0.273437 1.96164 0.56271 1.44665 1.07763C-4.37891 6.90318 13.0967 24.3787 18.9222 18.5532C19.4368 18.0381 19.7259 17.3399 19.7259 16.6118C19.7259 15.8837 19.4368 15.1854 18.9222 14.6704Z",
    fill: "#00607D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelIcon);
export default __webpack_public_path__ + "static/media/TelIcon.00ae1f9825262087960a32e7029dbc33.svg";
export { ForwardRef as ReactComponent };